export const T = {
    color: {
        // Synterra Health brand teal
        teal: {
            900: '#063B45',  // deepest dark teal
            800: '#0D5967',  // primary brand teal (hero, sidebar)
            700: '#115F72',  // slightly lighter
            600: '#1A7A8E',  // medium teal
            500: '#2A9BB0',  // lighter teal
            400: '#7DD0DE',  // light teal
            300: '#CEDDE0',  // brand mint — lightest teal bg
        },
        // Synterra Health brand hot pink — exact value: #E41871 (CTAs, accents)
        // Replaces prior purple-magenta; kept as "magenta" key to avoid renames
        magenta: {
            700: '#9E0E50',  // deep hot pink
            600: '#C41060',  // dark hot pink
            500: '#E41871',  // PRIMARY brand hot pink (buttons, highlights)
            400: '#F64291',  // lighter hot pink (gradient end)
        },
        coral: {
            600: '#C4374F',
            500: '#E8536A',
            400: '#EE7285',
        },
        surface: {
            canvas: '#EBF2F4',  // warm light teal-white
            light:  '#F4F8FA',
            white:  '#FFFFFF',
        },
        text: {
            primary:   '#0F0F0F',  // Synterra near-black
            secondary: '#54595F',  // Synterra secondary text
            muted:     '#7A7A7A',  // Synterra muted text
            inverse:   '#FFFFFF',
        },
        border: {
            light:  'rgba(13,89,103,0.08)',
            medium: 'rgba(13,89,103,0.14)',
        },
        glass: {
            bg:       'rgba(255,255,255,0.06)',
            bgMid:    'rgba(255,255,255,0.10)',
            bgLight:  'rgba(255,255,255,0.85)',
            border:   'rgba(255,255,255,0.14)',
        },
        status: {
            green:    '#16a34a',
            greenBg:  'rgba(22,163,74,0.10)',
            greenBdr: 'rgba(22,163,74,0.25)',
            amber:    '#d97706',
            amberBg:  'rgba(217,119,6,0.10)',
            amberBdr: 'rgba(217,119,6,0.25)',
            red:      '#dc2626',
            redBg:    'rgba(220,38,38,0.10)',
            redBdr:   'rgba(220,38,38,0.25)',
            blue:     '#2563eb',
            blueBg:   'rgba(37,99,235,0.08)',
            blueBdr:  'rgba(37,99,235,0.20)',
        },
    },
    gradient: {
        sidebar:  'linear-gradient(170deg, #063B45 0%, #0D5967 55%, #1A7A8E 100%)',
        hero:     'linear-gradient(135deg, #063B45 0%, #0D5967 55%, #1A7A8E 100%)',
        accent:   'linear-gradient(135deg, #E41871 0%, #F64291 100%)',
        teal:     'linear-gradient(135deg, #2A9BB0 0%, #1A7A8E 100%)',
        magenta:  'linear-gradient(135deg, #E41871 0%, #9E0E50 100%)',
        // Deep, sophisticated raspberry — used for AI/ML card. NOT neon.
        raspberry: 'linear-gradient(135deg, #9E0E50 0%, #C41060 55%, #9E0E50 100%)',
        canvas:   'radial-gradient(ellipse 80% 60% at 12% 0%, rgba(13,89,103,0.12) 0%, transparent 58%), radial-gradient(ellipse 60% 50% at 88% 100%, rgba(6,59,69,0.08) 0%, transparent 58%)',
        // Glass-sphere — dark raspberry-pink 3-D orb with highlight spot
        sphere:   'radial-gradient(circle at 38% 32%, rgba(240,140,180,0.68) 0%, rgba(164,18,86,0.86) 36%, rgba(110,8,58,0.96) 64%, rgba(70,4,38,1) 100%)',
    },
    radius: {
        xs:   4,
        sm:   8,
        md:   12,
        lg:   16,
        xl:   20,
        full: 9999,
    },
    shadow: {
        sm:          '0 1px 3px rgba(13,89,103,0.06), 0 1px 8px rgba(13,89,103,0.04)',
        md:          '0 2px 8px rgba(13,89,103,0.10), 0 4px 16px rgba(13,89,103,0.08)',
        lg:          '0 4px 24px rgba(13,89,103,0.14), 0 8px 40px rgba(13,89,103,0.08)',
        card:        '0 1px 4px rgba(0,0,0,0.04), 0 4px 16px rgba(13,89,103,0.08), 0 1px 0px rgba(255,255,255,0.9) inset',
        cardHover:   '0 8px 32px rgba(13,89,103,0.16), 0 2px 8px rgba(0,0,0,0.08)',
        sidebar:     '4px 0 32px rgba(6,59,69,0.32)',
        button:      '0 2px 8px rgba(13,89,103,0.20), 0 1px 3px rgba(0,0,0,0.12)',
        buttonHover: '0 4px 16px rgba(13,89,103,0.28), 0 2px 6px rgba(0,0,0,0.16)',
        coralGlow:   '0 0 14px rgba(232,83,106,0.42)',
        magentaGlow: '0 0 16px rgba(228,24,113,0.36)',
        // 3-D sphere shadow: inset highlight + top shadow gives glass-orb depth
        sphere:      'inset 0 -4px 10px rgba(0,0,0,0.38), inset 0 3px 6px rgba(255,255,255,0.18), 0 3px 14px rgba(0,0,0,0.40)',
    },
    font: {
        // Synterra brand fonts: Roboto (headings 600, body 400)
        family:        '"Roboto", "system-ui", "-apple-system", sans-serif',
        familyHeading: '"Roboto", "system-ui", sans-serif',
        weight: {
            normal:    400,
            medium:    500,
            semibold:  600,
            bold:      700,
            extrabold: 800,
        },
    },
} as const;
